import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import axios from "axios";
import details_m from '@/views/mobile/details_m';
import { api } from "@/api/api";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useHead } from '@vueuse/head';
export default {
  name: 'details',
  components: {
    details_m
  },
  setup() {
    const route = useRoute();
    const get_data = ref({});
    const store = useStore(); // 该方法用于返回store 实例
    const Client = store.state.Client;
    // 响应式变量保存从后台获取的数据
    const pageData = ref({
      title: '米魔口腔 - 新闻',
      description: '正在加载...'
    });

    // console.log(route.params);
    let url = api.baseUrl + api.details + '?id=' + route.params.id;
    axios({
      url,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      console.log(data);
      get_data.value = data.data;
      pageData.value.title = data.data.title;
      pageData.value.description = data.data.brief;
      // 页面标题和其他元数据
      useHead({
        title: pageData.value.title,
        meta: [{
          name: 'description',
          content: pageData.value.description
        }]
      });
    });
    return {
      get_data,
      Client
    };
  }
};